import atoms from "../../../../components/atoms";
import LostBarcodeTopSection from "./component/topSection";
import {
  BulkLostBarcodeProps,
  LostBarcodeProps,
  LostBarcodeTableProps,
} from "./interface";
const { Button, Table } = atoms;
const Index = ({
  lostBarcodeData,
  handleFileUpload,
  handleSubmit,
  erroredBarcode,
}: BulkLostBarcodeProps) => {
  const tableColumnStyle = (row: LostBarcodeTableProps) => ({
    fontWeight: row?.error ? "bold" : undefined,
    padding: row?.error ? "5px" : undefined,
    color: row?.error ? "red" : undefined,
  });

  // columns for table
  const columns = [
    {
      name: "S.No.",
      cell: (row: LostBarcodeTableProps) => {
        const style = tableColumnStyle(row);
        return <span style={style}>{row?.table_index}</span>;
      },
    },
    {
      name: "Barcode",
      cell: (row: LostBarcodeTableProps) => {
        const style = {
          border: !row?.barcode ? "2px solid" : undefined,
          ...tableColumnStyle(row),
        };
        return <span style={style}>{row?.barcode ? row?.barcode : "-"}</span>;
      },
    },
    {
      name: "Remark",
      cell: (row: LostBarcodeTableProps) => {
        const style = {
          border: !row?.remarks ? "2px solid" : undefined,
          ...tableColumnStyle(row),
        };
        return <span style={style}>{row?.remarks ? row?.remarks : "-"}</span>;
      },
    },
  ];
  // end

  // columns from error table
  const errorColumns = [
    ...columns,
    {
      name: "Error Message",
      cell: (row: LostBarcodeTableProps) => {
        const style = tableColumnStyle(row);
        return (
          <span style={style}>{row?.apiResponse ? row?.apiResponse : "-"}</span>
        );
      },
    },
  ];
  // end

  return (
    <div>
      <LostBarcodeTopSection handleFileUpload={handleFileUpload} />
      {erroredBarcode?.length > 0 && (
        <div>
          <Table
            columns={errorColumns}
            data={erroredBarcode?.map(
              (item: LostBarcodeProps, index: number) => {
                return {
                  ...item,
                  table_index: index + 1,
                };
              }
            )}
          />
        </div>
      )}
      {erroredBarcode?.length === 0 && <Table
        columns={columns}
        data={lostBarcodeData?.map((item: LostBarcodeProps, index: number) => {
          return {
            ...item,
            table_index: index + 1,
          };
        })}
      />}
      {(lostBarcodeData?.length > 0 && erroredBarcode?.length === 0) && (
        <div className="d-flex justify-content-center">
          <Button
            name={"Submit"}
            className="add-btn mt-2 mb-2"
            onClick={() => handleSubmit()}
          />
        </div>
      )}


    </div>
  );
};

export default Index;
